import { useIntl } from "react-intl";

import AccountCreation from "@/components/signup/account-creation";
import {
    WhiteScreenInput,
    WhiteScreenLayout,
    WhiteScreenSocial,
    WhiteScreenSubmit
} from "@/components/signup/layouts";

export const LoggedOutJiraStandard = () => {
    const intl = useIntl();
    const heading1 = intl.formatMessage(
        {
            id: "BxpUiSignup.SignupForm.header",
            defaultMessage: "Get started with {product}"
        },
        { product: "Jira" }
    );

    const heading2 = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.subheader.jsw.standard",
        defaultMessage:
            "14-day free trial for unlimited users on the Standard plan — no credit card needed"
    });

    return (
        <WhiteScreenLayout heading1={heading1} heading2={heading2}>
            <AccountCreation
                Input={<WhiteScreenInput />}
                Social={<WhiteScreenSocial />}
                Submit={<WhiteScreenSubmit />}
            />
        </WhiteScreenLayout>
    );
};
